var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitCustomerData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(_vm._s(_vm.$t("general.internal_process"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row  mb-4" }, [
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.rate_of_prepayment"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: {
                          invalid: _vm.$v.formData.rate_of_prepayment.$error,
                        },
                        attrs: { disabled: "disabled" },
                        model: {
                          value: _vm.formData.rate_of_prepayment,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "rate_of_prepayment", $$v)
                          },
                          expression: "formData.rate_of_prepayment",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.rate_of_prepayment.$error
                ? _c("div", [
                    !_vm.$v.formData.rate_of_prepayment.between
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("validation.enter_valid_tax_rate"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.kibor_amount"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        attrs: { disabled: "disabled" },
                        model: {
                          value: _vm.formData.kibor_amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "kibor_amount", $$v)
                          },
                          expression: "formData.kibor_amount",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.spread"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: { invalid: _vm.$v.formData.spread.$error },
                        model: {
                          value: _vm.spreadAmount,
                          callback: function ($$v) {
                            _vm.spreadAmount = $$v
                          },
                          expression: "spreadAmount",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.spread.$error
                ? _c("div", [
                    !_vm.$v.formData.spread.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("validation.enter_valid_tax_rate"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.financing_ratio"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: { invalid: _vm.$v.formData.margin_rate.$error },
                        model: {
                          value: _vm.formData.margin_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "margin_rate", $$v)
                          },
                          expression: "formData.margin_rate",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.margin_rate.$error
                ? _c("div", [
                    !_vm.$v.formData.margin_rate.between
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("validation.enter_valid_tax_rate"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.transaction_fees"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: {
                          invalid: _vm.$v.formData.transaction_fees.$error,
                        },
                        model: {
                          value: _vm.formData.transaction_fees,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "transaction_fees", $$v)
                          },
                          expression: "formData.transaction_fees",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.transaction_fees.$error
                ? _c("div", [
                    !_vm.$v.formData.transaction_fees.between
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("validation.enter_valid_tax_rate"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.longitude"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c("div", { staticClass: "base-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.formData.longitude,
                      expression: "formData.longitude",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "input-field",
                  class: { invalid: _vm.$v.formData.longitude.$error },
                  attrs: { type: "number", step: "any" },
                  domProps: { value: _vm.formData.longitude },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "longitude",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.latitude"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c("div", { staticClass: "base-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.formData.latitude,
                      expression: "formData.latitude",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "input-field",
                  class: { invalid: _vm.$v.formData.latitude.$error },
                  attrs: { type: "number", step: "any" },
                  domProps: { value: _vm.formData.latitude },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "latitude",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.price_cushion"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: {
                          invalid: _vm.$v.formData.price_cushion.$error,
                        },
                        model: {
                          value: _vm.formData.price_cushion,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "price_cushion", $$v)
                          },
                          expression: "formData.price_cushion",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.price_cushion.$error
                ? _c("div", [
                    !_vm.$v.formData.price_cushion.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [_vm._v(_vm._s(_vm.$t("validation.required")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$v.formData.price_cushion.between
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("validation.enter_valid_tax_rate"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.cost_cushion"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: { invalid: _vm.$v.formData.cost_cushion.$error },
                        model: {
                          value: _vm.formData.cost_cushion,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "cost_cushion", $$v)
                          },
                          expression: "formData.cost_cushion",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.cost_cushion.$error
                ? _c("div", [
                    !_vm.$v.formData.cost_cushion.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [_vm._v(_vm._s(_vm.$t("validation.required")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$v.formData.cost_cushion.between
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("validation.enter_valid_tax_rate"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row  mb-4" }, [
            _c(
              "div",
              { staticClass: "col-md-12 input-group" },
              [
                _c(
                  "base-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                      icon: "save",
                      color: "theme",
                      type: "submit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$tc("profile.business_status.save")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }